import React, { useEffect, useRef, useState } from "react";
import "./auth.css";
import login_rgt_img from "../../assets/Group 1261157977.png";
import OTPInput from "react-otp-input";
import { FiEdit3 } from "react-icons/fi";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { sendOtpApi, verifyOtpApi } from "../../services/auth";
import { Button } from "components/header/form";
import useResendOtp from "../../hooks/useResendOtp";
import { toastMessage } from "../../utils/toastMessage";
import { decryptData, encryptData } from "../../utils/dataCipher";
import { setToken } from "../../config/AxiosInstance";
import Slider from "react-slick";
import {
  SampleNextArrow,
  SamplePrevArrow,
} from "../../components/slider/Arrow";
import { socket } from "../../utils/socket";
import { logicalicon_blue } from "../../assets";
import { fetchToken } from "../../config/firebase/firebaseConfig";
import useButtonLoader from "hooks/useButtonLoader";
import { Spinner } from "react-bootstrap";

const Otp = () => {
  const resendTextRef = useRef(null);
  const [searchParam] = useSearchParams();

  let phone = searchParam.get("info") || {};
  let encryptedData;
  // Get the query string (encrypted data)
  if (Object.keys(phone).length) {
    encryptedData = decryptData(phone);
  }

  const { canResend, resetTimer } = useResendOtp(resendTextRef);
  const [submitButtonElement, setSubmitButtonElement] = useButtonLoader();
  const [submitButtonElement2, setSubmitButtonElement2] = useButtonLoader();

  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  // Resend Otp Handler
  const resendOtpHandler = async () => {
    try {
      setSubmitButtonElement2(true);
      setOtp("");
      const { data } = await sendOtpApi({
        dialCode: `${encryptedData?.dialCode}`,
        number: encryptedData?.number,
      });
      const isSuccess = data?.success;
      toastMessage(data?.message, isSuccess ? "success" : "error", "sendOtp");
      resetTimer();
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setSubmitButtonElement2(false);
    }
  };

  const handleVerifyOtp = async (resendOtp = false) => {
    try {
      setSubmitButtonElement(true);
      const notificationToken = await fetchToken();
      console.log("notificationToken", notificationToken);
      const payLoad = {
        dialCode: `${encryptedData?.dialCode}`,
        number: encryptedData?.number,
        otp: otp,
        notificationToken: notificationToken,
        deviceType: "WEB",
      }
      const { data } = await verifyOtpApi(payLoad);
      const { success, data: response, message } = data;
      const isSuccess = success;
      if (isSuccess) {
        if (response?.registered) {
          localStorage.removeItem("authInfo"); // Removing Phone Number From Local Storage
          setToken(response?.token);
          navigate("/dashboard/message/group");
          socket.auth = {
            token: response?.token,
          };
          socket.connect();
        } else {
          navigate(`/registration?info=${encryptData(encryptedData)}`);
        }
      }
      toastMessage(message, isSuccess ? "success" : "error", "sendOtp");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setSubmitButtonElement(false);
    }
  };

  var settings = {
    dots: true,
    infinite: true,
    arrow: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow to="next" />,
    prevArrow: <SamplePrevArrow to="prev" />,
  };

  useEffect(() => {
    if (otp.length === 4) {
      handleVerifyOtp();
    }
    // eslint-disable-next-line
  }, [otp.length]);

  return (
    <>
      <div className="auth otp">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-12">
              <div className="login_logo">
                <Link to="/">
                  <img src={logicalicon_blue} alt="" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 login_wrap">
              <div className="login_content_lft">
                <h2>Enter OTP</h2>
                <p>
                  We have sent a code to{" "}
                  <b className="phne_no">{`+${encryptedData?.dialCode}${" "}
                      ${encryptedData?.number}
                    `}</b>
                  &nbsp;&nbsp;
                  <FiEdit3
                    className="edit_icon"
                    onClick={() =>
                      navigate(`/login?info=${encryptData(encryptedData)}`)
                    }
                  />
                </p>

                <div className="form_field">
                  <h5>Please Enter 4 digit code</h5>
                  <div className="otp_wrap">
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={4}
                      inputStyle={"input"}
                      renderInput={(props) => (
                        <input
                          {...props}
                          disabled={submitButtonElement.disabled}
                        />
                      )}
                    />
                  </div>
                </div>

                {/* Next Btn */}

                <Button
                  onClick={handleVerifyOtp}
                  className={`button next-button`}
                  {...submitButtonElement}
                  disabled={otp.length < 4 || submitButtonElement.disabled}
                >
                  Verify OTP
                </Button>

                {canResend ? (
                  <Button
                    onClick={resendOtpHandler}
                    className={"w-100 light my-2"}
                    disabled={submitButtonElement2.disabled}
                  >
                    {submitButtonElement2.loading ? (
                      <Spinner variant="primary" />
                    ) : (
                      "Resend"
                    )}
                  </Button>
                ) : (
                  <div
                    ref={resendTextRef}
                    className="resend_otp"
                    onClick={() => (canResend ? resendOtpHandler() : "")}
                  >
                    You can resend OTP in <b>(30 second)</b>
                    {/* </div> */}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6 slider_content">
              <Slider {...settings}>
                <div className="login_img_rgt">
                  <img src={login_rgt_img} alt="" />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>

                <div className="login_img_rgt">
                  <img src={login_rgt_img} alt="" />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>

                <div className="login_img_rgt">
                  <img src={login_rgt_img} alt="" />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
